import { styled } from "@material-ui/core";
import { useLinked } from "@type-r/react";
import {
    CollapsableSection, Column,
    Flex,
    FormLabel,
    FormSelect, Option,
    div,
    span
} from "lqx-react/lib";
import * as React from "react";
import { AssetType } from "../../api/assetType";
import { DocumentSource } from "../../api/documentSource";
import { ImportTemplatesLookup } from "../../api/lookups";
import { DigiCheckbox, ErrorHighlighter } from "../../shared";
import { ConnectionsImportDetails } from "./connections-import-details";
import { FrequencyPicker } from './time-picker-dropdown';

export const ConnectionsPathCard = (
    { path, importTemplates, customerCompanyId }:
        { path: any, importTemplates: ImportTemplatesLookup, customerCompanyId: number }) => {

    const $useStandartMapping = useLinked(path.useStandardMapping).onChange(x => {
        path.useStandardMapping = !path.useStandardMapping;
        if (path.useStandardMapping) {
            path.importTemplateId = null;
        }
        path.fileCode = null;
    });

    React.useEffect(() => {
        path.fileCode = importTemplates && importTemplates.items.length && path.importTemplateId && !path.useStandardMapping ?
            importTemplates.items.find(_ => _.id === path.$.importTemplateId.value).assetType :
            path.fileCode;
        let destinationTargetDefault = { isEnabled: true, platform: '', product: '' };
        if (importTemplates && importTemplates.items.length) {
            if ($useStandartMapping.value) {
                if (path.$.fileCode.value) {
                    if (path.$.fileCode.value === AssetType[AssetType.invoice]) {
                        path.destinationTargets = [{ isEnabled: true, platform: '', product: '', assetTypeId: AssetType.invoice }];
                    }
                    if (path.$.fileCode.value === AssetType[AssetType.payment]) {
                        path.destinationTargets = [{ isEnabled: true, platform: '', product: '', assetTypeId: AssetType.payment }];
                    }
                    if (path.$.fileCode.value === DocumentSource.RemittanceAdvice.fileCode) {
                        path.destinationTargets = [{ isEnabled: true, platform: '', product: '', assetTypeId: AssetType.remittanceAdvice }];
                    }
                    if (path.$.fileCode.value === DocumentSource.UnappliedCash.fileCode) {
                        path.destinationTargets = [{ isEnabled: true, platform: '', product: '', assetTypeId: AssetType.unappliedCash }];
                    }
                    if (path.$.fileCode.value === DocumentSource.CustomerReferenceData.fileCode) {
                        path.destinationTargets = [{ isEnabled: true, platform: '', product: '', assetTypeId: AssetType.customerReferenceData }];
                    }
                } else {
                    path.destinationTargets = [];
                }
            } else {
                if (path.importTemplateId && path.$.importTemplateId.value) {
                    let assetTypes = importTemplates.items.find(_ => _.id === path.$.importTemplateId.value).assetTypes;
                    path.destinationTargets = [{ ...destinationTargetDefault, assetTypeId: assetTypes.models[0].id }];
                    if ((path.fileCode === "MultiAsset")) {
                        let destinationTargets = [];
                        assetTypes.each(a => destinationTargets.push({ ...destinationTargetDefault, assetTypeId: a.id }));
                        path.destinationTargets = destinationTargets;
                    }
                } else {
                    path.destinationTargets = [];
                }
            }
        }

    }, [path.$.importTemplateId.value, path.$.fileCode.value]);

    return path ? (<>
        <Flex row>
            <Column>
                <CollapsableSection
                    id="path-template"
                    title={`${path.emailFrom ? '' : 'File Path:'} ${path.emailFrom || path.path}`}>
                    <Flex row>
                        <Column>
                            <Flex row>
                                <Column></Column>
                                <Column><StyledFormLabel>{$useStandartMapping.value ? "Asset type*" : "Import Template*"}</StyledFormLabel></Column>
                                <Column><StyledFormLabel>Frequency* <Label>Every</Label></StyledFormLabel></Column>
                            </Flex>
                            <Flex row>
                                <Column>
                                    <DigiCheckboxContainer>
                                        <DigiCheckbox label="Standard Mapping" $checked={$useStandartMapping} />
                                    </DigiCheckboxContainer>
                                </Column>
                                <Column>
                                    <ErrorHighlighter>
                                        {$useStandartMapping.value ?
                                            <FormSelect $value={path.$.fileCode}>
                                                <Option value={AssetType[AssetType.invoice]}>Invoice</Option>
                                                <Option value={AssetType[AssetType.payment]}>Payment</Option>
                                                <Option value={DocumentSource.RemittanceAdvice.fileCode}>Remittance Advice</Option>
                                                <Option value={DocumentSource.UnappliedCash.fileCode}>Unapplied Cash</Option>
                                                <Option value={DocumentSource.CustomerReferenceData.fileCode}>Customer Reference Data</Option>
                                            </FormSelect> :
                                            <FormSelect $value={path.$.importTemplateId} disabled={!Boolean(customerCompanyId) || path.$.useStandardMapping.value}>
                                                {importTemplates.items.map((sm) => (<Option key={sm.id} value={sm.id}>{sm.name}</Option>))}
                                            </FormSelect>}
                                    </ErrorHighlighter>
                                </Column>
                                <Column>
                                    <FrequencyPicker
                                        $value={path.$.frequency}
                                        label={'Every'}
                                        stepMinutes={2}
                                    />
                                </Column>
                            </Flex>
                        </Column>
                    </Flex>
                    <Flex row>
                        <Column style={{ marginTop: '20px' }}>
                            {path.$.importTemplateId.value && importTemplates.items.length ?
                                <CollapsableSection id="import-template-details" title="Import Template Details">
                                    <ConnectionsImportDetails
                                        importDetails={importTemplates.items.find(_ => _.id === path.$.importTemplateId.value)}>
                                    </ConnectionsImportDetails>
                                </CollapsableSection> : <></>}
                        </Column>
                    </Flex>
                </CollapsableSection>
            </Column>
            <Column />
        </Flex>
    </>) : <></>;
}

const StyledFormLabel = styled(FormLabel)({
    alignSelf: 'start',
    paddingLeft: 4
})

const DigiCheckboxContainer = div({
    '& span': {
        color: '#767D84',
        fontSize: '12px',
        alignSelf: 'center',
        fontFamily: 'Montserrat',
        fontWeight: 500
    }
})

const Label = span({
    fontSize: '9px',
    color: '#DEDEDE',
    fontFamily: 'Montserrat',
    fontWeight: 500,
});